export enum RelationshipType {
  Parent = 'Parent',
  Sibling = 'Sibling',
  OtherFamilyMember = 'OtherFamilyMember',
  LegalGuardian = 'LegalGuardian',
  SupportCoordinator = 'SupportCoordinator',
  Other = 'Other',
}

export const RelationshipTypeToText = (e: RelationshipType) => {
  switch (e) {
    case RelationshipType.OtherFamilyMember:
      return 'Other Family Member';
    case RelationshipType.LegalGuardian:
      return 'Legal Guardian';
    case RelationshipType.SupportCoordinator:
      return 'Support Coordinator';
  }
  return e;
};

const buildDropdownOption = (e: RelationshipType) => {
  return { value: e, children: RelationshipTypeToText(e) };
};

export const relationships = [
  buildDropdownOption(RelationshipType.Parent),
  buildDropdownOption(RelationshipType.Sibling),
  buildDropdownOption(RelationshipType.OtherFamilyMember),
  buildDropdownOption(RelationshipType.LegalGuardian),
  buildDropdownOption(RelationshipType.SupportCoordinator),
  buildDropdownOption(RelationshipType.Other),
];
